import React from 'react'
import { Col } from 'reactstrap'

const Columns = (props: any) => {
  return <Col>{props.children}</Col>
}

export default Columns
